import { render, staticRenderFns } from "./SettingsDrawer.vue?vue&type=template&id=8d7aae0c&scoped=true"
import script from "./SettingsDrawer.vue?vue&type=script&lang=js"
export * from "./SettingsDrawer.vue?vue&type=script&lang=js"
import style0 from "./SettingsDrawer.vue?vue&type=style&index=0&id=8d7aae0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d7aae0c",
  null
  
)

export default component.exports